import dt from 'dayjs'
import * as lib from '../lib'
import { IFetchItems, IFetchOffer, IOffer } from '../types'

export const listOffer = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal: AbortSignal,
	token?: string | null,
): Promise<IFetchItems<IOffer>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take,
	}
	const uri: string = 'offer'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchOffer>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchOffer): IOffer => {
			const { createdAt, updatedAt, deletedAt, scope, ...row } = item
			return {
				...row,
				createdAt: dt(createdAt).toDate(),
				updatedAt: dt(updatedAt).toDate(),
				deletedAt: deletedAt ? dt(deletedAt).toDate() : null,
				...!!scope && {
					createdAt: dt(scope.createdAt).toDate(),
					updatedAt: dt(scope.updatedAt).toDate(),
				}
			}
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0,
	}
}
